import type { TFunction } from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { selectConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateAdditionalSalesData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'

const useVoltalisStatusRefresh = (saleType: string, t: TFunction) => {
  const dispatch = useDispatch()
  const { contactId } = useSelector(selectConfig) ?? {}
  const showNotification = useSnackbarNotification()

  const refresh = () => {
    // @ts-expect-error the JS slice actions are untyped
    dispatch(updateAdditionalSalesData({ name: saleType, data: { isLoading: true, statusFetchError: null } }))
    dispatch({
      type: subscriptionFormActionsV2.VOLTALIS_STATUS_URL,
      options: { subscriberId: `HOPV2C${contactId}` },
      saleName: saleType,
    })
    showNotification({ message: t('additionalSales:leadVoltalisBizdev.status_update_message') })
  }

  return { refresh }
}

export default useVoltalisStatusRefresh
